module.exports = __webpack_public_path__ + "static/media/banner1.7756c6e2.jpg";